"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Color {
    constructor(value) {
        this.value = value;
    }
    toString() {
        let value = this.value.toString(16);
        while (value.length < 6)
            value = '0' + value;
        return `#${value}`;
    }
}
Color.TILE = new Color(0x101010);
Color.CLUSTER = [
    new Color(0x0000ff),
    new Color(0x0000ff),
    new Color(0xffff00),
    new Color(0xff00ff),
    new Color(0x00ffff),
];
exports.Color = Color;
var Side;
(function (Side) {
    Side[Side["NORTH"] = 0] = "NORTH";
    Side[Side["SOUTH"] = 1] = "SOUTH";
    Side[Side["EAST"] = 2] = "EAST";
    Side[Side["WEST"] = 3] = "WEST";
    // UP,
    // DOWN,
})(Side = exports.Side || (exports.Side = {}));



//////////////////
// WEBPACK FOOTER
// ./src/config.ts
// module id = 1
// module chunks = 0